import { environment } from '../../environments/environment';

// Application Constants
export const APP_CONSTANTS = {
  API_URL: environment.apiUrl,
  AUTH_ENDPOINTS: {
    LOGIN: `${environment.apiUrl}/auth/login`,
    REGISTER: `${environment.apiUrl}/auth/register`,
    GOOGLE: `${environment.apiUrl}/auth/google`,
    FACEBOOK: `${environment.apiUrl}/auth/facebook`,
    ME: `${environment.apiUrl}/auth/me`,
    LOGOUT: `${environment.apiUrl}/auth/logout`
  },

  // Text Content
  TEXTS: {
    CONNECT_ACCOUNTS_TITLE: 'Connect Your Music Accounts',
    CONNECT_ACCOUNTS_SUBTITLE: 'Link your music services to unlock personalized AI-powered experiences',
    SPOTIFY_DESCRIPTION: 'Your music, playlists and musical preferences',
    DISCOGS_DESCRIPTION: 'Your collection and favorite releases',
    PROGRESS_COMPLETED: 'Completed',
    EXCELLENT_TITLE: 'Excellent!',
    BOTH_CONNECTED_DESCRIPTION: 'Both services are connected. You can now access all music intelligence features.',
    CONTINUE_TO_APP: 'Continue to Application',
    WHY_CONNECT_TITLE: 'Why connect these accounts?',
    LOADING_MESSAGE: 'Loading your music dashboard...',
    LOADING_SPOTIFY: 'Loading Spotify data...',
    LOADING_DISCOGS: 'Loading Discogs data...',
    LOADING_BOTH: 'Loading both Spotify and Discogs data...',

    // Connection Status Messages
    STATUS_MESSAGES: {
      NONE_CONNECTED: 'Connect your music accounts to get started.',
      ONE_CONNECTED: 'Great! Now connect the other service to continue.',
      BOTH_CONNECTED: 'Perfect! Both services are connected.'
    },

    // Button Labels
    BUTTONS: {
      CONNECT_SPOTIFY: 'Connect Spotify',
      CONNECT_DISCOGS: 'Connect Discogs',
      CONNECTED: 'Connected',
      DISCONNECT: 'Disconnect',
      CONNECTING: 'Connecting...',
      LOGOUT: 'Logout'
    },

    // Help Content
    HELP_ITEMS: [
      {
        icon: '🎵',
        title: 'Intelligent Analysis',
        description: 'We analyze your music to create personalized progressions'
      },
      {
        icon: '🧠',
        title: 'Personalized AI',
        description: 'AI learns from your taste for more accurate suggestions'
      },
      {
        icon: '🔒',
        title: 'Secure Data',
        description: 'Your musical information is protected and encrypted'
      }
    ]
  },

  // Colors & Branding
  COLORS: {
    SPOTIFY: {
      PRIMARY: '#1DB954',
      HOVER: '#1ED760',
      BACKGROUND: 'rgba(29, 185, 84, 0.2)'
    },
    DISCOGS: {
      PRIMARY: '#333333',
      HOVER: '#444444',
      BACKGROUND: 'rgba(51, 51, 51, 0.2)',
      BORDER: 'rgba(51, 51, 51, 0.3)'
    },
    SUCCESS: {
      PRIMARY: '#10B981',
      BACKGROUND: 'rgba(16, 185, 129, 0.1)',
      BORDER: 'rgba(16, 185, 129, 0.3)'
    },
    ERROR: {
      PRIMARY: '#EF4444',
      BACKGROUND: 'rgba(239, 68, 68, 0.1)',
      BORDER: 'rgba(239, 68, 68, 0.3)'
    },
    NEUTRAL: {
      BACKGROUND: '#0f0f23',
      CARD: 'rgba(22, 33, 62, 0.6)',
      BORDER: 'rgba(120, 119, 198, 0.2)',
      TEXT_PRIMARY: '#ffffff',
      TEXT_SECONDARY: '#a0aec0',
      ACCENT: '#7877c6'
    }
  },

  // API Endpoints
  API: {
    BASE_URL: environment.apiUrl,
    ENDPOINTS: {
      AUTH_ME: '/auth/me',
      SPOTIFY_AUTH: '/auth/spotify',
      DISCOGS_AUTH: '/auth/discogs',
      SPOTIFY_CONNECT: '/spotify/connect',
      DISCOGS_CONNECT: '/discogs/connect',
      SPOTIFY_PROFILE: '/spotify/me',
      SPOTIFY_LIKED_SONGS: '/spotify/liked-songs',
      SPOTIFY_PLAYLISTS: '/spotify/playlists',
      SPOTIFY_SYNC_LIBRARY: '/spotify/sync-library',
      DISCOGS_PROFILE: '/discogs/me',
      DISCOGS_WISHLIST: '/discogs/wishlist'
    }
  },

  // Routes
  ROUTES: {
    DASHBOARD: '/dashboard',
    DASHBOARD_OVERVIEW: '/dashboard/overview',
    LOGIN: '/login',
    AUTH_CALLBACK: '/music/callback',
    LOGIN_CALLBACK: '/auth/callback',
    SPOTIFY_CONNECT_CALLBACK: '/auth/spotify/connect',
    DISCOGS_CONNECT_CALLBACK: '/auth/discogs/connect',
    SPOTIFY_CALLBACK: '/auth/spotify/callback',
    DISCOGS_CALLBACK: '/auth/discogs/callback'
  },

  // Local Storage Keys
  STORAGE_KEYS: {
    MAIN_TOKEN: 'smartprogressions_token',
    SPOTIFY_TOKEN: 'spotify_token',
    DISCOGS_TOKEN: 'discogs_token'
  },

  // Animation Durations (ms)
  ANIMATIONS: {
    FAST: 200,
    NORMAL: 300,
    SLOW: 500,
    REDIRECT_DELAY: 1500
  }
};

// Service Names (for type safety)
export type ServiceName = 'spotify' | 'discogs';

// Progress Calculation
export const PROGRESS_WEIGHTS = {
  SPOTIFY: 50,
  DISCOGS: 50
};
